import { FocusMonitor } from '@angular/cdk/a11y';
import { AfterViewInit, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '@app/shared/models/dialog-data';
import { ConfirmationType, RequestType } from '@app/shared/types';
import { Subscription, finalize, take } from 'rxjs';
import { RequestConfirmationService } from '../services/request-confirmation.service';
import { ConfirmCodeSendType } from '../types/confirm-code-send-type.enum';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MousePressDirective } from '@app/shared/directives/mouse-press.directive';
import { MatButtonModule } from '@angular/material/button';
import { CountdownNewComponent } from '@app/shared/components/countdown/countdown-new.component';
import { TcPromiseNewDirective } from '@app/shared/directives/tc-promis-new.directive';
import { EmailSubstringPipe } from '@app/views/pages/p2p/pipes';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
    selector: 'tc-request-security-dialog',
    imports: [
        CommonModule,
        TranslateModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        FormsModule,
        TcPromiseNewDirective,
        CountdownNewComponent,
        MatFormFieldModule,
        MatInputModule,
        MousePressDirective
    ],
    templateUrl: './request-security-dialog.component.html',
    styleUrls: ['./request-security-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class RequestSecurityDialogComponent implements OnInit, AfterViewInit {
  submitSubscription: Subscription;
  sendCodeSubscription: Subscription;
  dialogData: DialogData;
  itemToDelete: string;
  confirmationType = ConfirmationType;
  securityCodeType: ConfirmCodeSendType;
  securityCodeTypes = ConfirmCodeSendType;
  securityCode: string;
  placeHolder: string;
  userContact: string;
  // numbers
  interval: number;
  verifyCodeLength = 6;

  //boolean
  isSendCodeLoading: boolean;
  timeIsExpired: boolean;
  constructor(
    private requestConfirmationService: RequestConfirmationService,
    private focusMonitor: FocusMonitor,
    private dialogRef: MatDialogRef<RequestSecurityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.securityCodeType = data.securityCodeType;
  }
  ngOnInit(): void {
    this.sendCode();
    this.generateRalatedText();

  }

  ngAfterViewInit(): void {
    // prevent focus on cancel button
    this.focusMonitor.stopMonitoring(document.getElementById('btnCancel'));
  }

  /*******************************************************************
 Private
 *******************************************************************/

  private resetSecurityCode(): void {
    this.timeIsExpired = true;
    this.securityCode = '';
  }

  private handelResponseForExpireTime(response: any): void {
    const expierTimeSec = response['expireTimeSec'];
    this.interval = expierTimeSec;
    this.verifyCodeLength = response['verifyCodeLength'];
    this.timeIsExpired = false;
  }

  private generateRalatedText(): void {
    switch (this.securityCodeType) {
      case ConfirmCodeSendType.Email:
        this.placeHolder = "GENERAL.EMAIL";
        this.userContact = this.requestConfirmationService.userInfoData.information.userName;
        break;
      case ConfirmCodeSendType.SMS:
        this.placeHolder = "GENERAL.SMS";
        let userContact = this.requestConfirmationService.userInfoData.information.phoneNumber;
        let startIndex = userContact.indexOf("_");
        userContact = userContact.substring((startIndex + 1), userContact.length);
        userContact = userContact.substring(0, 3) + "***" + userContact.substring(6, userContact.length);
        this.userContact = userContact;
        break;
      default:
        break;

    }
  }


  /*******************************************************************
    Public
  *******************************************************************/

  onTimerFinished(): void {
    document.getElementById('sendBtn').focus();
    this.resetSecurityCode();
  }

  sendCode(): void {
    if (this.securityCodeType == ConfirmCodeSendType.TwoFactorAuthentication) {
      return;
    }
    this.isSendCodeLoading = true;
    this.sendCodeSubscription = this.requestConfirmationService.sendCodeForRequestConfirm(RequestType.Withdrawal)
      .pipe(
        take(1),
        finalize(() => { this.isSendCodeLoading = false; })
      )
      .subscribe((response: any) => {
        this.handelResponseForExpireTime(response);
        document.getElementById('codeInput').click();
      });
  }


  public close(): void {
    this.dialogRef.close();
  }

  public confirm(): void {
    this.dialogRef.close(this.securityCode);
  }
}
